<main>
  <div class="container">
    <div class="flex-row justify-center">
      <mat-card class="flex-grow">
        <mat-card-header>
          <mat-card-title>Smart Check</mat-card-title>
          <mat-card-subtitle>Anmeldung</mat-card-subtitle>
        </mat-card-header>
        <form
          id="loginForm"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
          novalidate
        >
          <mat-card-content>
            <mat-form-field appearance="outline">
              <mat-label>E-Mail / Benutzername</mat-label>
              <input
                matInput
                placeholder="E-Mail / Benutzername"
                formControlName="userName"
                autocomplete="username"
                data-cy="username"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Passwort</mat-label>
              <input
                matInput
                [type]="passwordHidden ? 'password' : 'text'"
                placeholder="Passwort"
                formControlName="password"
                autocomplete="current-password"
                data-cy="password"
              />
              <mat-icon matSuffix (click)="passwordHidden = !passwordHidden">{{
                passwordHidden ? 'visibility' : 'visibility_off'
              }}</mat-icon>
            </mat-form-field>
            <span class="on-error-fixed">{{ responseMessage }}</span>
          </mat-card-content>
          <mat-card-actions>
            <button
              id="forgot-password"
              type="button"
              mat-button
              data-cy="forgot-password"
              (click)="onForgottenPassword()"
            >
              Passwort vergessen
            </button>
            <button id="submit" data-cy="submit" mat-button mat-flat-button>
              Einloggen
            </button>
          </mat-card-actions>
        </form>
      </mat-card>
    </div>
  </div>

  <tariff-check-footer></tariff-check-footer>
</main>
